import styled, { css } from "styled-components";

const Container = styled.div`
    width: 100%;

    >.orgchart-container {
        border: 2px dashed var(--border-color);
        background-color: var(--modal-body);
        overflow: hidden;
        height: auto;
        min-height: 100%;
        margin: 10px 0;

        .orgchart {
            min-width: 100%;
            min-height: 100%;
            background-image: none;
            background: rgba(0, 0, 0, 0.01);
            border: 1px dotted rgba(0, 0, 0, 0.015);
            border-radius: 20px;
            box-shadow: 0 1px 3px rgba(0,0,0,0.04), 0 1px 2px rgba(0,0,0,0.04);

            > ul {
                justify-content: center;
            }

            > ul > li > ul li > .oc-node::before,
            ul li .oc-node:not(:only-child)::after{
                background: var(--main-color);
            }

            > ul > li > ul li::before{
                border-top: 2px solid var(--main-color);
            }

            ul li .oc-node{
                margin-bottom: 25px;
                &.selected, &:hover{
                    background-color: var(--border-color);
                }
            }

            ul li .oc-node:not(:only-child)::after{
                bottom: -16px;
                height: 17px;
            }

            .focusThisCard{
                position: absolute; 
                top: 120px;
                right: 20px;
                cursor: pointer;
            }

            .oc-node .bottomEdge,
            .oc-node .topEdge,
            .oc-node .verticalEdge,
            .oc-node .rightEdge,
            .oc-node .leftEdge{
                display: none;
            }
         }
        
    }
`;

export const Node = styled.div`

    .title {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        background-color: var(--purple-light);
        color: var(--grey-softer);
        border-radius: 0 0 1px 1px;
        border: 1px solid var(--purple-light);
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.6), 0 1px 2px rgba(0, 0, 0, 0.3);
        width: 360px;
        padding: 0 20px 0 8px;
        font-size: 14px;
        font-weight: 700;
        height: auto;
        min-height: 30px;
        overflow: inherit;
        text-overflow: clip;
        white-space: pre-wrap;

        span {
            color: var(--grey-softer);
            font-weight: 700;
            font-size: 14px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }

        .symbol {
            position: absolute;
            margin: 0;
            margin-right: 2px;
            margin-top: -6px;
            top: 20px;
            left: 10px;
            color: var(--grey-softer);
            &::before {
                background-color: transparent !important;
            }
        }
    }

    .content {
        display: flex;
        flex-direction: row;
        position: relative;
        border-radius: 0 0 1px 1px;
        border: 1px solid rgba(0,0,0,0.1);
        height: auto;
        color: var(--default-color-font);
        background: var(--card-background);
        min-height: 100px;
        font-size: 12px;
        padding: 8px 10px;
        box-shadow: 0 1px 3px rgba(0,0,0,0.36), 0 1px 2px rgba(0,0,0,0.2);
        
        .info-card-responsible{
            display:flex;
            align-items: center;
            margin-left: -15px;
            margin-top: 2px;
            margin-bottom: 2px;
            max-width: fit-content;
        }

        .container-chart-percentage{
            display: flex;
            transition: 100ms;
            &:hover{
                cursor: pointer;
            }
        }
                
        .container-info-card {
            display: flex;
            flex-direction: column;
            height: 100%;
            width: 80%;
            text-align: left;
            padding: 0 10px 5px 10px;

            .info-card-buttons {
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
                padding: 2px 0 2px 4px;
                button {
                    border: 0;
                    color: var(--blue);
                    margin: 0 5px;
                    font-size: 13px;
                    background: transparent;
                    display: flex;
                    align-items: center;
                    svg{
                        margin-right: 2px;
                    }
                }
                span{
                    display: flex;
                    align-items: center;
                    svg{
                        margin-right: 2px;
                    }
                }
            }
            .info-card-display-number-key-results{
                width: 100%;
                max-width: 230px;
                display:flex;
                align-items:center;

                >span.title-of-kr{
                    font-size: 12px;
                    margin-right: 10px;
                    white-space: pre-wrap;
                }
            }
            
            .info-card-number-key-results {
                width: 100%;
                max-width: 230px;
                display:flex;
                align-items:center;

                >div:last-child{
                    display: none;
                }

                >span.title-of-kr{
                    font-size: 12px;
                    margin-right: 10px;
                    white-space: pre-wrap;
                }
            }

        }

        &.content.content-key-results {
            background-color: var(--input-background-color);
            padding: 4px;
            min-height: 90px;
            & .container-info-card {
                padding: 1px 1px 1px 19px;
            }

            &.card-border-left-warning{
                border-left: 4px solid var(--color-warning) !important;
            }

            &.card-border-left-danger {
                border-left: 4px solid var(--color-danger) !important;
            }

            &.card-border-left-success {
                border-left: 4px solid var(--color-success) !important;
            }

            &:hover{
                .info-card-number-key-results >div:last-child{
                    display: flex;
                }
            }
        }

    }


`;

export const buttonUnderlineStyles = css`
	font-size: 10px; 
	line-height: 12px; 
	color: var(--blue); border: 0; 
	background: transparent; 
	display: flex; 
	align-items: center;
	&:hover{
		text-decoration: underline;
	}
`;

export const optionsStyles = css`
    >ul{
        z-index: 1;
        li{
            display: flex;
            &::before{
                content: none !important;
            }
        }
    }
`;

export const DivKRsSons = styled.div`
    display: flex;
    flex-direction: column;
`;

export default Container;
